import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import utils from './utils/reducer';


const reducers = combineReducers({
  menu,
  settings,
  authUser,
  utils
});

export default reducers;